import { get, post } from '../axios'

// 查询四要素字典
export function common_getDict_get(map, option) {
  return get(`${process.env.VUE_APP_ADMIN}/common/getDict`, map, option).then(
    response => response
  )
}

// 谷歌翻译
export function common_googleTranslate_post(map, option) {
  return post(
    `${process.env.VUE_APP_ADMIN}/common/googleTranslate`,
    map,
    option
  ).then(response => response)
}

// 查询语言信息
export function common_queryLanguageMapping_post(map, option) {
  return post(
    `${process.env.VUE_APP_ADMIN}/common/queryLanguageMapping`,
    map,
    option
  ).then(response => response)
}

// 查询站点列表
export function common_querySiteTerminals_post(map, option) {
  return post(
    `${process.env.VUE_APP_ADMIN}/common/querySiteTerminals`,
    map,
    option
  ).then(response => response)
}

// 刷新四要素字典缓存
export function common_refreshDictCache_get(map, option) {
  return get(
    `${process.env.VUE_APP_ADMIN}/common/refreshDictCache`,
    map,
    option
  ).then(response => response)
}

// 查询站点信息
export function common_siteById_get(map, option) {
  return get(`${process.env.VUE_APP_ADMIN}/common/siteById`, map, option).then(
    response => response
  )
}

// 查询站点信息
export function common_siteByName_get(map, option) {
  return get(
    `${process.env.VUE_APP_ADMIN}/common/siteByName`,
    map,
    option
  ).then(response => response)
}

// 更新四要素字典
export function common_upsertDict_post(map, option) {
  return post(
    `${process.env.VUE_APP_ADMIN}/common/upsertDict`,
    map,
    option
  ).then(response => response)
}
